import {createAction} from '@reduxjs/toolkit'

export const updateChats = createAction('chats/save', (data) => ({
  payload: data
}))
